module.exports = __webpack_public_path__ + "static/fonts/MyriadPro-SemiExt.bb2e13d.eot";